module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ded"
  }, [_vm._v("This book is dedicated "), _c('br'), _vm._v("to the 13 million Jews and the 1,300 million Muslims in the world"), _c('br'), _vm._v("in the hope that they may renew"), _c('br'), _vm._v("in the Twenty–First Century"), _c('br'), _vm._v("the mutual tolerance, respect and partnership"), _c('br'), _vm._v("that marked many periods in their history")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e0270226","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/dedication.vue
// module id = 69
// module chunks = 0